<script lang="ts">
    import { service } from "@frontend/services";
    import { AddGameDTO, ApiResultOfListOfGame, ApiResultOfPublicGamesDTO, AuthenticatedRequestOfAddGameDTO, GameServerDTO } from "@frontend/walletapi";
    import "../helpers";
    import { AppendPath, ToFormData } from "../helpers";
    import { GetCachedToken } from "@frontend/user";
    import { translate, currentLanguage } from "../Translator";

    export let dismiss: () => void;

    let fileInput: HTMLInputElement;
    let newGame = {
        GameName: '',
        GameCode: '',
        Enabled: true,
        Select: '', 
        Image: undefined as File | undefined,
        TokenId: '',
        GameServerId: 0
    };

    let result: ApiResultOfPublicGamesDTO | undefined = undefined;
    let gameName = "";
    let gameDescription = "";
    let Select = "";
    let error = "";
    let loading = false;
    let gameServers: GameServerDTO[] = [];

    // Cargar la lista de servidores al iniciar
    async function loadGameServers() {
        try {
            const response = await service.walletapi.gameServerList({
                Token: GetCachedToken()
            });
            if (response.Success && response.Data) {
                gameServers = response.Data;
            }
        } catch (err) {
            console.error("Error loading game servers:", err);
        }
    }

    // Cargar servidores al montar el componente
    loadGameServers();

    async function AddGame() {
        // if (!fileInput.files)
        // {
        //     // no image selected
        //     return;
        // }

        const addGameDTO: AddGameDTO = {
            GameName: newGame.GameName,
            GameCode: newGame.GameCode,
            Enabled: newGame.Enabled,
            GameServerId: newGame.GameServerId || 0,
            Select: newGame.Select
        };

        const addGameRequest: AuthenticatedRequestOfAddGameDTO = {
            Token: GetCachedToken(),
            Data: addGameDTO,
        };

        try {
            const formData = new FormData();

            // Append AddGamesDTO JSON string as a part of the FormData
            ToFormData(addGameRequest, formData, "addGame");

            // Comentamos la parte de la imagen
            // formData.append('file', fileInput.files[0]);

            const responseHeaders = await fetch(service.Route("/AddGame"), {
                method: 'POST',
                body: formData
            });

            const response: ApiResultOfListOfGame = await responseHeaders.json();

            if (response.Success)
            {
                console.log("Game added successfully:", response.Data);
                dismiss();
            }
            else
            {
                console.error("Error adding game:", response.ErrorMessage);
            }

        } catch (error) {
            console.error("Error adding game:", error);
        }
    }
        
    async function Cleanform() {
        result = undefined;
        newGame = { GameName: '', GameCode: '', Enabled: true, Select: '', Image: undefined, TokenId: '', GameServerId: 0 };
    }

    async function handleSubmit() {
        try {
            loading = true;
            error = "";

            const result = await service.walletapi.addGame({
                Token: GetCachedToken(),
                Data: {
                    GameName: gameName,
                    GameCode: gameName.toLowerCase().replace(/\s+/g, '-'),
                    Select: newGame.Select,
                    Enabled: true,
                    GameServerId: 0
                }
            });

            if (result.Success) {
                dismiss();
            } else {
                error = result.Message || "Error adding game";
            }
        } catch (err) {
            error = err instanceof Error ? err.message : "An unexpected error occurred";
        } finally {
            loading = false;
        }
    }

</script>


<h2 class="ui centered dividing header">{$translate('Add Game')}</h2>
{#if result && result.Success && result.Data}
    <div class="ui positive message">
        <div class="header">
             Game added successfully
        </div>
    </div>

    <div class="ui segment" style="display: flex;">
        <table class="receit-table" style="flex-grow: 1;">
            <tr>
                <td class="receit-title">{$translate('Id')}</td>
                <td class="receit-value">#{result.Data.Id}</td>
            </tr>
            <tr>
                <td class="receit-title">{$translate('Game Name')}</td>
                <td class="receit-value">{result.Data.GameName}</td>
            </tr>
            <tr>
                <td class="receit-title">{$translate('Game code')}</td>
                <td class="receit-value">{result.Data.GameCode ?? ""}</td> 
            </tr>
            <tr>
                <td class="receit-title">{$translate('Imagen')}</td>
                <td class="receit-value">
                    <input type="file" class="ui input" accept="image/*"  />
                </td> 
            </tr>
            <tr>
                <td class="receit-title">{$translate('Enabled')}</td>
                <td class="receit-value">{result.Data.Enabled ?? ""}</td>
            </tr>
        </table>
    </div>

    <div style="display: flex; justify-content: center;">
        <button class="ui primary fluid button" on:click={dismiss}>{$translate('Dismiss')}</button>
        <button class="ui fluid button">{$translate('Print')}</button>
    </div>
{:else}
    {#if result && !result.Success}
        <div class="ui negative message">
            <div class="header">Error</div>
            <p>{result.ErrorMessage ?? "Unknown error when adding player"}</p>
        </div>
    {/if}
    <div class="ui form">
        <div class="field">
            <label>{$translate('Game Name')}
                <input type="text" class="ui input" bind:value={newGame.GameName} placeholder="Enter game name" required />
            </label>
        </div>
        <div class="field">
            <label>{$translate('Game code')}
                <input type="text" class="ui input" bind:value={newGame.GameCode} placeholder="Enter game code" required />
            </label>
        </div>
        <div class="field">
            <label>{$translate('Imagen')}
                <input type="text" class="ui input" bind:value={newGame.Select} placeholder="Enter game image URL" required />
            </label>
        </div>
        <div class="field">
            <label>{$translate('Endpoint')}
                <select class="ui dropdown" bind:value={newGame.GameServerId}  placeholder="Enter Game Server " required>
                    <option value="">Select a game server</option>
                    {#each gameServers as server}
                        <option value={server.Id}>{server.Label}</option>
                    {/each}
                </select>
            </label>
        </div>
        {#if error}
            <div class="ui negative message">
                <p>{error}</p>
            </div>
        {/if}
        <div class="field">
            <button class="ui primary button" on:click={AddGame} disabled={loading}>
                {#if loading}
                    <i class="spinner loading icon"></i>
                {/if}
                {$translate('Add Game')}
            </button>
            <button class="ui button" on:click={dismiss}>{$translate('Cancel')}</button>
        </div>
    </div>
{/if}

<style>
    .receit-table
    {
        border-spacing: 0px;
        font-family: 'Courier New', Courier, monospace;
    }

    .receit-table td
    {
        padding-top: 5px;
    }

    .receit-table td:first-child
    {
        margin-right: 0.2em;
    }

    .receit-title
    {
        text-align: left;
        border-bottom: 1px solid black;
        padding-right: 10px;
    }

    .receit-value
    {
        text-align: right;
        border-bottom: 1px solid black;
    }

    .ui.form {
        padding: 1em;
    }
    .field {
        margin-bottom: 1em;
    }
    .ui.input {
        width: 100%;
    }
</style>


